var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"position-relative w-100 p-2"},[_c('internal-notes',{attrs:{"api-endpoints":_vm.internalNotesEndpoint,"user-type":'client',"is-program":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }